import { render, staticRenderFns } from "./OrderPortray.vue?vue&type=template&id=174aba2c"
import script from "./OrderPortray.vue?vue&type=script&lang=js"
export * from "./OrderPortray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports